import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";

import { MyExamsListPage } from "./my-exams-list.page";
import { SharedComponentsModule } from "@app/components/shared-components.module";
import { SharedModule } from "@app/shared/shared.module";

@NgModule({
  imports: [
    SharedComponentsModule,
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule
  ],
  declarations: [MyExamsListPage],
})
export class MyExamsListPageModule {}
